<template>
    <div class="userInfo" v-loading="loading">
        <div class="header-box">
            <h2 class="form-title">Basic Information</h2>
            <p class="form-subtitle">Manage your personal details and profile picture</p>
        </div>
        
        <el-form :ref="formData" :model="formData" label-position="left" label-width="120px">
            <el-form-item label="Profile Photo">
                <div class="avatar-wrap">
                    <el-upload
                      class="avatar-uploader"
                      :action="action"
                      :headers="headers"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess">
                      <div class="avatar-preview">
                          <img v-if="formData.avatar" :src="formData.avatar" class="avatar">
                          <div v-else class="avatar-placeholder">
                              <i class="el-icon-plus"></i>
                          </div>
                          <div class="edit-overlay">
                              <i class="el-icon-camera"></i>
                          </div>
                      </div>
                    </el-upload>
                    <div class="upload-tip">
                        <p class="tip-main">Upload a new photo</p>
                        <p class="tip-sub">Recommended: Square image, max 2MB</p>
                    </div>
                </div>
            </el-form-item>
            
            <div class="form-grid">
                <el-form-item label="User ID">
                    <div class="readonly-field">
                        <span class="value">#{{formData.id}}</span>
                        <i class="el-icon-lock icon"></i>
                    </div>
                </el-form-item>
                
                <el-form-item label="Phone Number">
                    <div class="readonly-field">
                        <span class="value">{{formData.phone}}</span>
                        <i class="el-icon-lock icon"></i>
                    </div>
                </el-form-item>
                
                <el-form-item label="Nickname">
                    <el-input 
                        v-model="formData.nickname" 
                        placeholder="Enter your nickname"
                        clearable>
                    </el-input>
                </el-form-item>
            </div>

            <el-form-item class="form-actions mar-top-60">
                <el-button class="btn-secondary" @click="getUserInfo">Discard Changes</el-button>
                <el-button class="btn-primary" :loading="btnLoading" @click="onSubmit">Save Profile</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import {uploadURL} from '@/api/user.js'
import { getToken } from '@/axios/cookies.js'
import {
    getUserInfo,
    editUserInfo
} from '@/api/login.js'
export default {
    name: 'userInfo',
    data () {
        return {
            formData: {},
            action: uploadURL,
            imageUrl: '',
            loading: false,
            btnLoading: false
        }
    },
    computed: {
        headers() {
            return {
                Authorization: 'Bearer ' + getToken()
            }
        }
    },
    mounted () {
        this.getUserInfo()
    },
    methods: {
        // 获取用户信息
        async getUserInfo () {
            this.loading = true
            var res = await getUserInfo()
            if (res.status === 200) {
                this.formData = res.data
                this.loading = false
            } else {
                this.$message.warning(res.msg)
            }
        },
        // 上传图片
        handleAvatarSuccess (res) {
            this.formData.avatar = res.data
        },
        // 修改
        onSubmit () {
            this.btnLoading = true
            editUserInfo({
                avatar: this.formData.avatar,
                nickname: this.formData.nickname
            }).then(res => {
                if (res.status === 200) {
                    this.$message.success('Profile updated successfully')
                    this.$store.commit('SET_USERINFO', this.formData)
                } else {
                    this.$message.warning(res.msg)
                }
            })
            this.btnLoading = false
        }
    }
}
</script>
<style lang="scss" scoped>
.userInfo {
    padding: 40px;
    background-color: #fff;
    border-radius: 20px;
    box-shadow: $shadow-sm;
    border: 1px solid $gray-100;

    .header-box {
        margin-bottom: 40px;
        .form-title {
            font-size: 24px;
            font-weight: 700;
            color: $gray-900;
            margin-bottom: 8px;
        }
        .form-subtitle {
            font-size: 14px;
            color: $gray-500;
        }
    }

    .avatar-wrap {
        display: flex;
        align-items: center;
        gap: 24px;

        .avatar-uploader {
            .avatar-preview {
                position: relative;
                width: 100px;
                height: 100px;
                border-radius: 50%;
                overflow: hidden;
                background: $gray-50;
                border: 2px solid $white;
                box-shadow: $shadow-md;
                cursor: pointer;
                transition: $transition-base;

                .avatar {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .avatar-placeholder {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    font-size: 24px;
                    color: $gray-300;
                }

                .edit-overlay {
                    position: absolute;
                    inset: 0;
                    background: rgba($black, 0.4);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: $white;
                    font-size: 20px;
                    opacity: 0;
                    transition: $transition-base;
                }

                &:hover {
                    transform: scale(1.02);
                    box-shadow: $shadow-lg;
                    .edit-overlay { opacity: 1; }
                }
            }
        }

        .upload-tip {
            .tip-main {
                font-size: 15px;
                font-weight: 600;
                color: $gray-800;
                margin-bottom: 4px;
            }
            .tip-sub {
                font-size: 12px;
                color: $gray-400;
            }
        }
    }

    .form-grid {
        max-width: 600px;
        margin-top: 24px;
    }

    .readonly-field {
        height: 48px;
        padding: 0 16px;
        background: $gray-50;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid $gray-100;

        .value {
            font-family: 'Inter', sans-serif;
            font-weight: 500;
            color: $gray-700;
        }
        .icon {
            color: $gray-300;
            font-size: 14px;
        }
    }

    >>> .el-form-item {
        margin-bottom: 24px;
        
        .el-form-item__label {
            font-weight: 600;
            color: $gray-700;
            padding-top: 4px;
        }

        .el-input__inner {
            height: 48px;
            border-radius: 12px;
            border-color: $gray-200;
            padding: 0 16px;
            transition: $transition-base;

            &:focus {
                border-color: $primary-color;
                box-shadow: 0 0 0 4px rgba($primary-color, 0.1);
            }
        }
    }

    .form-actions {
        border-top: 1px solid $gray-100;
        padding-top: 32px;
        margin-top: 40px;

        .btn-primary {
            min-width: 140px;
            height: 48px;
            background: $primary-color;
            border-color: $primary-color;
            color: $white;
            border-radius: 12px;
            font-weight: 700;
            font-size: 15px;
            box-shadow: 0 4px 12px rgba($primary-color, 0.2);
            transition: $transition-base;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 16px rgba($primary-color, 0.3);
                opacity: 0.9;
            }
        }

        .btn-secondary {
            min-width: 140px;
            height: 48px;
            background: $white;
            border: 1px solid $gray-200;
            color: $gray-600;
            border-radius: 12px;
            font-weight: 600;
            font-size: 15px;
            transition: $transition-base;

            &:hover {
                background: $gray-50;
                border-color: $gray-300;
                color: $gray-900;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/userInfo/index.vue